<template>
    <div class="login">
        <h1>登录</h1>
        <div class="ht">
            <div class="ti">邮箱</div>
            <div class="ip"><input type="text" v-model="email"></div>
        </div>
        <div class="ht">
            <div class="ti">密码</div>
            <div class="ip"><input type="password" v-model="password"></div>
        </div>
        <div class="btn" @click="login">登录</div>

    </div>
</template>

<script>

    export default {
        name: 'login',
        data() {
            return {
                base: null,
                email: '',
                password: '',
                redirect: undefined//LOGO前是哪个页面，到时候要转过去
            }
        },
        mounted() {
        },
        watch: {
            $route: {
                handler(route) {
                    this.redirect = route.query && route.query.redirect
                },
                immediate: true
            }
        },
        methods: {
            async login() {
                const {data} = await this.$supabase.auth.signInWithPassword({
                    email: this.email,
                    password: this.password,
                })
                if (data.user != null) {
                    this.$message({
                        message: '登錄成功',
                        type: 'success',
                        onClose: () => {
                            this.$router.push({path: this.redirect || '/'})
                        }
                    });
                } else {
                    this.$message({
                        message: '账号输入错误',
                        type: 'error',
                    });
                }

            }
        }
    }
</script>
<style scoped>
    .login {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 15px;
    }

    .login h1 {
        font-weight: normal;
        font-size: clamp(26px, 3vw, 40px);
        padding: 30px 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 5px
    }

    .login .ht {
        display: flex;
        align-items: stretch;
        margin-bottom: 15px;
        height: 42px;
        width: 100%;
        max-width: 300px;
    }

    .login .ht .ti {
        background: var(--green);
        width: 80px;
        color: var(--white);
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .login .ht .ip {
        border: solid 1px var(--line);
        width: calc(100% - 80px);
    }

    .login .ht .ip input {
        width: 100%;
        height: 100%;
        border: none;
        outline: none;
        padding: 0 15px;
    }


    .login .btn {
        background: var(--yellow);
        padding: 15px 30px;
        color: var(--white);
        cursor: pointer;
    }
</style>

